import BigNumber from "bignumber.js";

export const formatCoinFiatPrice = (price: number) => {
  return price > 1 ? BigNumber(price).toFormatExtended(2) : BigNumber(price).toFormatExtended(4);
};
